export const REDUCER_UPDATE_DATE = 'REDUCER_UPDATE_DATE'
export const REDUCER_UPDATE_DEVICE = 'REDUCER_UPDATE_DEVICE'
export const REDUCER_UPDATE_ENVELOPE_BY_DEVICE = 'REDUCER_UPDATE_ENVELOPE_BY_DEVICE'


